import React, { useContext } from 'react'
import { FormContext } from '../../context/form/FormContext';
import QuestionName from '../styleComponents/QuestionName';

const MultipleChoice = ({ id, question, qDescription, answersM = [], answers = []}) => {
    const { handleChange } = useContext(FormContext)
    return (
        <>
          <QuestionName questionName={question} description={qDescription}/>
          {answersM.map((radio, i) =>
            <div 
              onClick={() =>handleChange(id, { target: { value: radio }})} 
              className={`form-check multiple_choice ${answers && answers.includes(radio) ? 'multiple_choice-active' : 'multiple_choice-inactive'}`} 
              key={`${i}-${id}`}>
              <input 
                checked={answers && answers.includes(radio)}
                className="form-check-input multiple-choice-input" 
                id={`${i}-${id}`} 
                name={`${i}-${id}`} 
                onChange={() => {}} 
                type="checkbox" 
                value={radio}
              />
              <label className="form-check-label" htmlFor={i} >{radio}</label>
            </div>
          )}
        </>
    )
}

export default MultipleChoice
